import type { CheckoutError } from '@/scopes/checkout/domain/types'
import type { APIBookingDraftError } from '@/scopes/checkout/infrastructure/api/types'

export interface BookingDraftErrorMapper {
  map: (bookingDraft: APIBookingDraftError) => CheckoutError | null
}

export function createBookingDraftErrorMapper(): BookingDraftErrorMapper {
  function map(error: APIBookingDraftError): CheckoutError | null {
    if (!error)
      return null
    if (!error.hasError)
      return null

    let redirectTo: 'search' | 'acco' | 'subscription' = 'acco'
    if (error.redirectUrlToSearchPage)
      redirectTo = 'search'
    else if (error.redirectUrlToSubscriptionPage)
      redirectTo = 'subscription'

    return {
      hasError: error.hasError,
      message: error.description ?? error.errorMessage ?? '',
      redirectUrl: error.redirectUrlToSearchPage ?? error.redirectUrlToAccoPage ?? error.redirectUrlToSubscriptionPage ?? '',
      redirectTo,
      errorCode: error.errorCode ?? '',
      typeOfError: error.typeOfError ?? '',
    }
  }

  return { map }
}
